<template>
  <div>
    <component
        v-for="(item, name) in items"
        :key="name"
        :name="name"
        :is="item.component"
        :filters="filters"
        v-bind="item"
        @filter-change="filterChange"
        @labels-change="labelsChange"
    ></component>
  </div>
</template>

<script>
export default {
  props: {
    namespace: {
      type:String,
      default: 'filter1'
    },
  },

  computed: {
    /**
     * @return {Object}
     */
    filters() {
      return this.$store.state[this.namespace].filters;
    },

    /**
     * @return {Object}
     */
    items() {
      return this.$store.state[this.namespace].items;
    },
  },

  methods: {
    /**
     * @param {string} name
     * @param {Object} values
     */
    filterChange({name, values}) {
      this.$store.commit(`${this.namespace}/updateFilters`, {name, values});
    },

    /**
     * @param {string} name
     * @param {Array} values
     */
    labelsChange({name, values}) {
      this.$store.commit(`${this.namespace}/updateLabels`, {name, values});
    },
  },
}
</script>
